import { NextPage } from 'next'

import BouncingImage from '@/components/bouncingImage'
import DownloadApps from '@/components/downloadApps'
import FeatureItem from '@/components/featureItem'
import LayoutWithNavigation from '@/components/layoutWithNavigation'
import PageHeader from '@/components/pageHeader'
import Picture from '@/components/picture'
import SoilStep from '@/components/soilStep'
import { appList, featureItem, steps } from '@/constants/knowYourSoil'
import STRINGS from '@/constants/strings'

export async function getStaticProps() {
  return {
    props: {
      title: STRINGS.KNOW_YOUR_SOIL.PAGE_TITLE,
      description: STRINGS.KNOW_YOUR_SOIL.PAGE_DESCRIPTION,
    },
  }
}

const KnowYourSoil: NextPage = () => {
  return (
    <LayoutWithNavigation>
      <>
        <section className="px-6 my-4 max-w-7xl m-auto">
          <PageHeader
            heading={STRINGS.KNOW_YOUR_SOIL.KNOW_YOUR_SOIL}
            subHeading={STRINGS.KNOW_YOUR_SOIL.SOIL_TESTING_AND_HEALTH_CARD}
          />
          <section className="flex md:flex-row flex-col">
            <div className="md:flex-1 pt-4">
              <p className="whitespace-pre-wrap mb-2.5 text-footer-grey text-base font-natosans-light">
                {STRINGS.KNOW_YOUR_SOIL.DESCRIPTION}
              </p>
              <div className="py-2.5">
                <DownloadApps apps={appList} />
              </div>
            </div>
            <div className="md:w-1/3 md:px-4 py-2.5">
              <Picture
                image="/assets/images/know-your-soil/lab"
                imageAlt="Sprouting seedling"
                loading="eager"
                imageStyle="w-full"
              />
            </div>
          </section>
          <section className="mt-[50px]">
            <h2 className="text-xl md:text-3xl pt-4 pb-[30px] font-natosans-medium">
              {STRINGS.KNOW_YOUR_SOIL.STEPS_INVOLVED_IN_SOIL_TESTING}
            </h2>
            <ul className="flex md:flex-row flex-col md:space-x-9">
              {steps.map(({ key, ...step }, index) => (
                <li key={key} className="flex-1 pr-9">
                  <SoilStep index={index + 1} {...step} />
                </li>
              ))}
            </ul>
          </section>
        </section>
        <section className="bg-[#081621] py-[30px] mt-[50px]">
          <div className="px-6 max-w-7xl m-auto pt-2.5">
            <h2 className="text-white text-[45px] leading-normal font-natosans-medium tracking-[2px] mt-5 mb-2.5">
              {STRINGS.KNOW_YOUR_SOIL.HEALTH_CARD}
            </h2>
            <div className="flex md:flex-row flex-col">
              <ul className="flex-1 md:px-4">
                {featureItem.map(({ key, ...feature }) => (
                  <li key={key}>
                    <FeatureItem
                      {...feature}
                      titleStyle="text-[#6bb51e] text-xl my-2.5"
                      descriptionStyle="text-white text-sm mb-2.5"
                      imageContainerStyle="pt-4 mt-2.5"
                      imageStyle="w-16 aspect-square"
                    />
                  </li>
                ))}
              </ul>
              <div className="flex-1 md:mt-0 mt-[60px]">
                <BouncingImage
                  image="/assets/images/know-your-soil/health-card"
                  imageAlt={STRINGS.KNOW_YOUR_SOIL.HEALTH_CARD}
                />
              </div>
            </div>
          </div>
        </section>
      </>
    </LayoutWithNavigation>
  )
}

export default KnowYourSoil
